import React, { useEffect, useRef, useState } from "react";
import {
  Form,
  Input,
  Spin,
  Select,
  InputNumber,
  Divider,
  Space,
  Modal,
} from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import PhoneInput from "react-phone-input-2";
import { save } from "./../../../../../../features/save/saveSlice";
import {
  fetchData,
  fetchLocation,
  fetchSubCounties,
  fetchSubLocation,
} from "../../../../../../features/fetch/fetchSlice";

const MembersAdd = ({ isModalOpen, handleCancel, handleFetch, prodd }) => {
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const { saving } = useSelector((state) => state.save);

  const {
    wtrSources,
    counties,
    subCounties,
    locations,
    subLocations,
    memberTypes,
    schemeCrop,
    schemeBlocks,
  } = useSelector((state) => state.fetch);
  const { activeObj, iwuaObj } = useSelector((state) => state.obj);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const urlWard = "ward/fetch_wards";
  const urlConstituency = "constituency/fetch_constituencys";
  const { dataConstituency, dataWard } = useSelector((state) => ({
    dataWard: state.fetch.data[urlWard] || [],
    dataConstituency: state.fetch.data[urlConstituency] || [],
  }));

  const [countyId, setCountyId] = useState(prodd?.countyId ?? "");
  const [usrConstId, setUsrConstId] = useState(prodd?.usrConstId ?? "");
  const [subCountyId, setSubCountyId] = useState(prodd?.subCountyId ?? "");
  const [locationId, setLocationId] = useState(prodd?.locationId ?? "");
  const [subLocationId, setSubLocationId] = useState(
    prodd?.subLocationId ?? ""
  );
  const [usrWdId, setUsrWdId] = useState(prodd?.usrWdId ?? "");

  const handleCountyChange = async (value) => {
    setCountyId(value);
    setUsrConstId("");
    setSubCountyId("");
    setLocationId("");
    setSubLocationId("");
    setUsrWdId("");

    form.setFieldsValue({
      countyId: value,
      usrConstId: "",
      subCountyId: "",
      locationId: "",
      subLocationId: "",
      usrWdId: "",
    });

    await dispatch(fetchSubCounties({ subCountyId: value }));
    await dispatch(fetchData({ url: urlConstituency, constCounty: value }));
  };

  const handleConstituencyChange = async (value) => {
    setUsrConstId(value);
    setUsrWdId("");

    form.setFieldsValue({
      usrConstId: value,
      usrWdId: "",
    });

    await dispatch(fetchData({ url: urlWard, wdConst: value }));
  };

  const handleSubCountyChange = async (value) => {
    setSubCountyId(value);
    setLocationId("");
    setSubLocationId("");

    form.setFieldsValue({
      subCountyId: value,
      locationId: "",
      subLocationId: "",
    });

    await dispatch(fetchLocation({ locSubId: value }));
  };

  const handleLocationChange = async (value) => {
    setLocationId(value);
    setSubLocationId("");

    form.setFieldsValue({
      locationId: value,
      subLocationId: "",
    });

    await dispatch(fetchSubLocation({ slocLocId: value }));
  };

  const handleSubLocationChange = (value) => {
    setSubLocationId(value);
    form.setFieldsValue({ subLocationId: value });
  };

  const handleWardChange = (value) => {
    setUsrWdId(value);
    form.setFieldsValue({ usrWdId: value });
  };

  const onFinish = async (data) => {
    data.usrId = prodd?.usrId ? prodd?.usrId : null;
    data.farmId = prodd?.farmId ? prodd?.farmId : null;
    data.majorCrops = Array.isArray(data?.majorCrops)
      ? data?.majorCrops.join(",")
      : data?.majorCrops;
    data.farmBlocks = Array.isArray(data?.farmBlocks)
      ? data?.farmBlocks.join(",")
      : data?.farmBlocks;
    data.usrInstId = iwuaObj?.instId;
    const res = await dispatch(
      save({
        ...data,
        url: "prod/member",
      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.message);
      await handleFetch();
      await form.resetFields();
      await handleCancel();
    } else {
      toast.error(res?.payload?.message);
    }
  };

  useEffect(() => {
    if (prodd) {
      form.setFieldsValue({
        ...prodd,
        farmBlocks: prodd?.farmBlocks?.split(",")?.map((b) => b?.trim()),
      });
      dispatch(
        fetchSubCounties({
          subCountyId: prodd?.countyId,
        })
      );
      dispatch(
        fetchData({ url: urlConstituency, constCounty: prodd?.countyId })
      );
      dispatch(fetchData({ url: urlWard, wdConst: prodd?.usrConstId }));
      dispatch(
        fetchLocation({
          locSubId: prodd?.subCountyId,
        })
      );
      dispatch(
        fetchSubLocation({
          slocLocId: prodd?.locationId,
        })
      );
    } else {
      form.resetFields();
    }
  }, [prodd, form]);

  useEffect(() => {
    setCountyId(prodd?.countyId ?? "");
    setUsrConstId(prodd?.usrConstId ?? "");
    setSubCountyId(prodd?.subCountyId ?? "");
    setLocationId(prodd?.locationId ?? "");
    setSubLocationId(prodd?.subLocationId ?? "");
  }, [prodd]);

  return (
    <Modal
      title={`${prodd?.usrId ? "Update IWUA Member" : "Add IWUA Member"}`}
      open={isModalOpen}
      onOk={onFinish}
      onCancel={handleCancel}
      className="!w-[59.5rem]"
      maskClosable={false}
    >
      <Form
        layout="vertical"
        ref={formRef}
        name="control-ref"
        onFinish={onFinish}
        className=""
        style={{
          maxWidth: "100%",
        }}
        form={form}
      >
        <div className="flex items-center gap-x-5">
          <div className="bg-[#EDF8FF] w-[3.5rem] h-[3.5rem] rounded-full flex justify-center items-center">
            <span className="paragraph_paragraph_bb08">1</span>
          </div>
          <span className="paragraph_paragraph_bb13">Personal Details</span>
        </div>

        <div className="ml-[5rem] grid lg:grid-cols-2 grid-cols-1 lg:gap-x-10">
          <Form.Item
            name="usrNationalId"
            label="ID Number"
            rules={[
              {
                required: true,
                message: "National ID is required",
              },
              {
                validator(_, value) {
                  if (value && value.toString().length < 6) {
                    return Promise.reject(
                      "National ID must be at least 6 characters long"
                    );
                  }
                  return Promise.resolve();
                },
              },
            ]}
          >
            <InputNumber
              min={0}
              parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
              className="input flex"
            />
          </Form.Item>
          <Form.Item
            name="fullNames"
            label={"Name"}
            rules={[
              {
                required: true,
                message: "Please add name",
              },
            ]}
          >
            <Input className="input" />
          </Form.Item>
          <Form.Item
            name="email"
            label={"Email"}
            rules={[
              {
                required: false,
                message: "Please add email address",
              },
              {
                type: "email",
                message: "Please enter a valid email address",
              },
            ]}
          >
            <Input type="email" className="input" />
          </Form.Item>
          <Form.Item
            name="phoneNumber"
            label={"Active Phone Number"}
            rules={[
              {
                required: true,
                message: "Please add primary phone no",
              },
            ]}
          >
            <PhoneInput
              country="ke"
              onlyCountries={["ke"]}
              countryCodeEditable={false}
              className="input rounded-[6px] border !border-[#cacaca] !h-[42px]"
            />
          </Form.Item>
          <Form.Item
            name="usrMemberType"
            className=""
            label={"Member Type"}
            rules={[
              {
                required: true,
                message: "Please select member type",
              },
            ]}
          >
            <Select
              className=""
              allowClear
              style={{
                width: "100%",
              }}
              options={
                memberTypes?.length > 0 &&
                memberTypes?.map((item) => ({
                  value: item?.mbType,
                  label: item?.mbType,
                }))
              }
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                (option?.label?.toLocaleLowerCase() ?? "").includes(
                  input?.toLocaleLowerCase()
                )
              }
            />
          </Form.Item>
        </div>
        <div className="flex items-center gap-x-5 mt-[2.38rem]">
          <div className="bg-[#EDF8FF] w-[3.5rem] h-[3.5rem] rounded-full flex justify-center items-center">
            <span className="paragraph_paragraph_bb08">2</span>
          </div>
          <span className="paragraph_paragraph_bb13">Details</span>
        </div>
        <div className="ml-[5rem] grid lg:grid-cols-2 grid-cols-1 lg:gap-x-10">
          <Form.Item
            name="countyId"
            label="County"
            rules={[{ required: true, message: "Please select county" }]}
          >
            <Select
              allowClear
              options={counties?.map((c) => ({
                value: c?.countyId,
                label: c?.countyName,
              }))}
              onChange={handleCountyChange}
              showSearch
              filterOption={(input, option) =>
                option?.label?.toLowerCase()?.includes(input.toLowerCase())
              }
            />
          </Form.Item>

          {countyId && (
            <>
              <Form.Item
                name="usrConstId"
                label="Constituency"
                rules={[
                  { required: true, message: "Please select constituency" },
                ]}
              >
                <Select
                  allowClear
                  options={dataConstituency?.map((c) => ({
                    value: c?.constId,
                    label: c?.constName,
                  }))}
                  onChange={handleConstituencyChange}
                  showSearch
                  filterOption={(input, option) =>
                    option?.label?.toLowerCase()?.includes(input.toLowerCase())
                  }
                />
              </Form.Item>

              <Form.Item
                name="subCountyId"
                label="Subcounty"
                rules={[{ required: true, message: "Please select subcounty" }]}
              >
                <Select
                  allowClear
                  options={subCounties?.map((s) => ({
                    value: s?.subId,
                    label: s?.subCountyName,
                  }))}
                  onChange={handleSubCountyChange}
                  showSearch
                  filterOption={(input, option) =>
                    option?.label?.toLowerCase()?.includes(input.toLowerCase())
                  }
                />
              </Form.Item>
            </>
          )}

          {subCountyId && (
            <Form.Item
              name="locationId"
              label="Location"
              rules={[{ required: true, message: "Please select location" }]}
            >
              <Select
                allowClear
                options={locations?.map((l) => ({
                  value: l?.locId,
                  label: l?.locLocation,
                }))}
                onChange={handleLocationChange}
                showSearch
                filterOption={(input, option) =>
                  option?.label?.toLowerCase()?.includes(input.toLowerCase())
                }
              />
            </Form.Item>
          )}

          {locationId && (
            <Form.Item
              name="subLocationId"
              label="Sublocation"
              rules={[{ required: true, message: "Please select sublocation" }]}
            >
              <Select
                allowClear
                options={subLocations?.map((sl) => ({
                  value: sl?.slocId,
                  label: sl?.slocLocation,
                }))}
                onChange={handleSubLocationChange}
                showSearch
                filterOption={(input, option) =>
                  option?.label?.toLowerCase()?.includes(input.toLowerCase())
                }
              />
            </Form.Item>
          )}

          {usrConstId && (
            <Form.Item
              name="usrWdId"
              label="Ward"
              rules={[{ required: true, message: "Please select ward" }]}
            >
              <Select
                allowClear
                options={dataWard?.map((w) => ({
                  value: w?.id,
                  label: w?.wdWard,
                }))}
                onChange={handleWardChange}
                showSearch
                filterOption={(input, option) =>
                  option?.label?.toLowerCase()?.includes(input.toLowerCase())
                }
              />
            </Form.Item>
          )}

          <Form.Item
            name="landSize"
            label={"Land Size (Acre)"}
            rules={[
              {
                required: true,
                message: "Please add land size",
              },
            ]}
          >
            <Input suffix="Acre" className="input" />
          </Form.Item>
          <Form.Item
            label="Major Crops"
            name="majorCrops"
            rules={[{ required: true, message: "Required field" }]}
          >
            <Select
              mode="multiple"
              allowClear
              showSearch
              dropdownRender={(menu) => (
                <>
                  <Space style={{ padding: "8px 8px 4px" }}>
                    <span className="select-info mt-1">
                      Choose one or more of the following crops
                    </span>
                  </Space>
                  <Divider style={{ margin: "8px 0" }} />
                  {menu}
                </>
              )}
              optionFilterProp="children"
              filterOption={(input, option) =>
                (option?.children?.toLowerCase() ?? "").includes(
                  input.toLowerCase()
                )
              }
              tagRender={(props) => {
                const { label, closable, onClose } = props;
                return (
                  <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      padding: "4px 8px",
                      margin: "2px",
                      borderRadius: "4px",
                      background: "#f5f5f5",
                    }}
                  >
                    {label}
                    {closable && (
                      <span
                        onClick={onClose}
                        style={{
                          marginLeft: "8px",
                          cursor: "pointer",
                          color: "red",
                        }}
                      >
                        ×
                      </span>
                    )}
                  </span>
                );
              }}
              dropdownStyle={{ maxHeight: 400, overflowY: "auto" }}
            >
              {schemeCrop?.length > 0 &&
                schemeCrop?.map((item) => (
                  <Select.Option key={item?.blkcId} value={item?.blkcCrop}>
                    {item?.blkcCrop}
                  </Select.Option>
                ))}
            </Select>
          </Form.Item>
          <Form.Item
            label={"Blocks"}
            name="farmBlocks"
            rules={[
              {
                required: true,
                message: "Select blocks",
              },
            ]}
          >
            <Select
              className="!h-full"
              mode="multiple"
              allowClear
              showSearch
              dropdownRender={(menu) => (
                <>
                  <Space style={{ padding: "8px 8px 4px" }}>
                    <span className="select-info mt-1">
                      Choose one or more of the following blocks
                    </span>
                  </Space>
                  <Divider style={{ margin: "8px 0" }} />
                  {menu}
                </>
              )}
              optionFilterProp="children"
              filterOption={(input, option) =>
                (option?.children?.toLowerCase() ?? "").includes(
                  input.toLowerCase()
                )
              }
              tagRender={(props) => {
                const { label, closable, onClose } = props;
                return (
                  <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      padding: "4px 8px",
                      margin: "2px",
                      borderRadius: "4px",
                      background: "#f5f5f5",
                    }}
                  >
                    {label}
                    {closable && (
                      <span
                        onClick={onClose}
                        style={{
                          marginLeft: "8px",
                          cursor: "pointer",
                          color: "red",
                        }}
                      >
                        ×
                      </span>
                    )}
                  </span>
                );
              }}
              dropdownStyle={{ maxHeight: 400, overflowY: "auto" }}
            >
              {schemeBlocks?.length > 0 &&
                schemeBlocks?.map((item) => (
                  <Select.Option key={item?.blocId} value={item?.blocId}>
                    {item?.blocName}
                  </Select.Option>
                ))}
            </Select>
          </Form.Item>

          <Form.Item
            name="altWaterSource"
            label={"Alternative Water Source"}
            rules={[
              {
                required: false,
                message: "Please add water source",
              },
            ]}
          >
            <Input className="input" />
          </Form.Item>
        </div>

        <div className="flex items-center gap-x-5 mt-[2.38rem]">
          <div className="bg-[#EDF8FF] w-[3.5rem] h-[3.5rem] rounded-full flex justify-center items-center">
            <span className="paragraph_paragraph_bb08">3</span>
          </div>
          <span className="paragraph_paragraph_bb13">
            Alternate Contact person
          </span>
        </div>

        <div className="ml-[5rem] grid lg:grid-cols-2 grid-cols-1 lg:gap-x-10">
          <Form.Item
            name="alternateContact"
            label={"Name"}
            rules={[
              {
                required: false,
                message: "Please add name",
              },
            ]}
          >
            <Input className="input" />
          </Form.Item>
          <Form.Item
            name="alternatePhoneNumber"
            label={"Phone Number"}
            rules={[
              {
                required: false,
                message: "Please add alternate phone no",
              },
            ]}
          >
            <PhoneInput
              country="ke"
              onlyCountries={["ke"]}
              countryCodeEditable={false}
              className="input rounded-[6px] border !border-[#cacaca] !h-[42px]"
            />
          </Form.Item>
        </div>

        <div className="flex justify-between mt-[48px] ">
          <div className="justify-start"></div>
          <div className="justify-end flex items-center mb-[58px] gap-x-5">
            <div className="w-[150px]">
              <button
                type="button"
                key="back"
                onClick={handleCancel}
                className="cstm-btn"
              >
                Cancel
              </button>
            </div>

            <div className="w-[150px]">
              <button
                disabled={saving}
                key="submit"
                type="submit"
                className="cstm-btn-2"
              >
                {saving ? <Spin /> : prodd?.usrId ? "Update" : "Create"}
              </button>
            </div>
          </div>
        </div>
      </Form>
    </Modal>
  );
};
export default MembersAdd;
